import type React from 'react';

import { useAppState } from '../AppStateProvider';
import { EmptyStateView } from '../components/EmptyStateView';
import { Header } from '../components/Header';
import { LoadingView } from '../components/LoadingView';
import { useCompaniesQuery } from '../features/company/useCompaniesQuery';
import { useDisabledPageView } from '../hooks/useDisabledPageView';

import { isCompanyDataPresent } from './company-overview/MultipleDomainsContainer/utils';
import { CompanyPage } from './CompanyPage';

export const EmailPage: React.FC = () => {
  const companiesQuery = useCompaniesQuery();
  const { collectedEmail } = useAppState();

  const { isDisabledPageVisible, disabledPageView } = useDisabledPageView();

  const isCompaniesDataPresent = Boolean(
    companiesQuery?.data?.length && companiesQuery?.data.some((company) => isCompanyDataPresent(company))
  );

  if (isDisabledPageVisible) {
    return disabledPageView;
  }

  if (companiesQuery.isLoading) {
    return (
      <>
        <Header />
        <LoadingView />
      </>
    );
  }

  if (collectedEmail && !isCompaniesDataPresent) {
    return (
      <>
        <Header />
        <EmptyStateView
          textKey="email.empty_state.text"
          messageKey="email.empty_state.message"
          img="/images/empty-state-lens.svg"
          variant="lens-rised"
        />
      </>
    );
  }

  return <CompanyPage />;
};
